import { useEffect } from 'react';
import { decrypt } from '../../MIS/encryption';
import { getQuotations, quotationDelete, quotationUpdate } from '../Service/quotationService';
import { apiGet } from '../Service/apiClient';

export const handleGetAddons_list = async ({  
  setLoading,
  setAddons,
  }) => {
  // setLoading(true);
  try {
    const resData = await apiGet("addons", {page:1,limit:100});    
    setAddons(resData?.data)
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    // setLoading(false);
  }
};

export const handleGetPrintAddons_list = async ({  
  setLoading,
  setPrintAddons,singleQuote
  }) => {
  setLoading(true);
  try {
    const resData = await apiGet("sublimation_print_addon",
     {page:1,limit:100});         
     const quantityMap = Object.fromEntries(
      (singleQuote?.prints || []).map((q) => [q.print_addon_id, true])
    );    
    const updatedData = (resData?.data || []).filter((product) =>
      quantityMap[product.id]
    ).map((product) => ({
      ...product
    }));        
    setPrintAddons(updatedData)
  } catch (error) {    
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetQuotations=async({ data,
   setQuotations, setLoading, showToast,setTotalPage })=>{  
  setLoading(true);
  try {    
    const resData=await getQuotations(data);
    setQuotations(resData?.data);
    setTotalPage(resData?.total_pages)    
  } catch (error) {
    showToast("Something went wrong! Please try again", 'danger');
  }finally{
    setLoading(false);
  }
}


export const useDefaultLoad = ({ filter, setQuotations, setLoading, showToast,setTotalPage,page }) => {
  useEffect(() => {      
    if(filter !== undefined){
      let data=filter;
      handleGetQuotations({ data, setQuotations, setLoading, showToast,setTotalPage })    
    }     
  }, [page]);
};

export const useHandleUserOrderPath = (
  { location, setHideAdminElements}) => {
  useEffect(() => {      
    const isYourOrderPage = location.pathname === "/yours-order";
    if(isYourOrderPage===true){
      setHideAdminElements(false);
    }
  }, []);
};


export const updateStatus=async({quote,quotations,setQuotations,
  showToast,due_date,setStatusLoading,status})=>{
  try {
    let quoteStatus=status;
    if(quoteStatus!=="Accepted"){due_date="-"}        
    setStatusLoading(true)
    const resData=await quotationUpdate({id:quote?.id,quote_status:quoteStatus,due_date:due_date})     
    if(resData?.data > 0)   
    {
      const updatedData = quotations.map(item =>
        item.id === quote?.id ? { ...item, 
          quote_status:quoteStatus,due_date:due_date } : item
      );
      showToast(`Quotation ${quoteStatus} successfully`, 'success');
      setQuotations(updatedData);
    }else{
      showToast("Something went wrong! Please try again", 'danger');  
    }
  } catch (error) {
    showToast("Something went wrong! Please try again", 'danger');
  }finally{
    setStatusLoading(false)
  }
}

export const handleQuoteDelete=async({quote,quotations,setQuotations,showToast})=>{
  
  try {    
    const resData=await quotationDelete({id:quote?.id}) 
    if(resData?.data > 0)   
    {
      const updatedData = quotations.filter(item => item.id !== quote?.id);
      showToast(`Quotation deleted successfully`, 'success');
      setQuotations(updatedData);
    }else{
      showToast("Something went wrong! Please try again", 'danger');  
    }
  } catch (error) {
    showToast("Something went wrong! Please try again", 'danger');
  }
}


export const handleChangeSearch=({value,setSearch,setFilter})=>{
  setSearch(value);
  let newData={p_search:value.trim()}
  setFilter((prev) => ({
    ...prev,
    ...newData,
  }));

}

export const handlePrev = ({setPage,page,setFilter}) => {
    const newPage = Math.max(page - 1, 1); 
    setFilter((prev) => ({
      ...prev,
      page:newPage,
    }));
    setPage((prev) => Math.max(prev - 1, 1));
 };

export const handleNext = ({setPage,page,totalPage,setFilter}) => {
    const newPage = Math.min(page + 1, totalPage);  
    setFilter((prev) => ({
      ...prev,
      page:newPage,
    }));
    setPage((prev) => Math.min(prev + 1, totalPage));
 };  

export const getAddonNameById = ({addons_id,addons}) => {
  const addon = addons?.find(p => p.id === addons_id);
  return addon ? addon.addon_name : "Not Found";
};

export const calcSubTotal = (subTotal,addonTotal) => {
   let sub=Number(subTotal)-Number(addonTotal);
   return sub;
};

export const getGstIs = (gst) => {
  if( Number(gst) > 0){
    return '';
  }else{
    return 'd-none';
  }
};

export const getType = (type ) => {
  if( Number(type) === 1){
    return 'T-Shirt';
  }else{
    return 'Upper';
  }
};

export const handleStatus_Label = (quote_status) => {
  const statusMap = {
    Pending: "bg-warning text-dark",
    Accepted: "bg-success",
    Cancelled: "bg-danger",
    Processing: "bg-primary",
    Draft: "bg-secondary",
  }; 

  return statusMap[quote_status];
};